import React from 'react';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import DataCard from '../_shared/DataCard';

const PracticeFeedbackReportsContainer = () => (
  <DataCard.Container direction="column">
    <DataCard.Content
      title={t(
        'insights.practice_feedback.learners_requesting_feedback_report.report_title',
      )}
      subtitle={t(
        'insights.practice_feedback.learners_requesting_feedback_report.report_subtitle',
      )}
      labsBadgeDescription={t('insights.more_reports.description')}
    >
      <a
        href={
          routes.INSIGHTS.PRACTICE_FEEDBACK.LEARNERS_REQUESTING_FEEDBACK_REPORT
        }
        className="DataCard-link"
      >
        <Icon name="download" /> {t('common.download')}
      </a>
    </DataCard.Content>
    <DataCard.Content
      title={t(
        'insights.practice_feedback.learners_receiving_feedback_report.report_title',
      )}
      subtitle={t(
        'insights.practice_feedback.learners_receiving_feedback_report.report_subtitle',
      )}
      labsBadgeDescription={t('insights.more_reports.description')}
    >
      <a
        href={
          routes.INSIGHTS.PRACTICE_FEEDBACK.LEARNERS_RECEIVING_FEEDBACK_REPORT
        }
        className="DataCard-link"
      >
        <Icon name="download" /> {t('common.download')}
      </a>
    </DataCard.Content>
  </DataCard.Container>
);

export default PracticeFeedbackReportsContainer;
